// Settings configured here will be merged into the final config object.
export default {
  apiRootUrl: 'http:/www.host.com/api/',
  chat: {
    glyphRegEx: () => /\[glyph:([a-z\-]+)\]/g,
  },
  companionNeeded: false,
  companionBaseUrl: 'http://localhost:81/api/'
};



// WEBPACK FOOTER //
// ./config/base.js